import { Handle, Position, useNodesData } from "@xyflow/react";
import { message } from "antd";

import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { Button } from "V2.0/common/button";
import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";
import { validateNodeConfig } from "../NodeConfigure/nodeValidation";
import { NodeUIRegistry } from "../Models/nodeUIRegistry";
import { NodeType } from "../Models/NodeType";
import {
  Node,
  NodeActions,
  NodeBadge,
  NodeBody,
  NodeHeader,
  NodeName,
} from "./Components/Node";
import AddStepAction from "./Components/AddStepAction";
import ConfigureStepAction from "./Components/ConfigureStepAction";
import NodeExecutionStatusBadge, {
  NodeExecutionStatus,
} from "./Components/NodeExecutionStatus";
import { useMemo } from "react";
import usePipelineNode from "./Hooks/usePipelineNode";
import { TWebhookTriggerNodeConfig } from "../Models/WebhookTrigger";

export default WebhookTriggerNode;

const baseUrl = process.env.REACT_APP_API_URL;

function WebhookTriggerNode(props) {
  const { id } = props;

  const {
    data,
    onDelete,
    handleAdd,
    isExecuted,
    workspaceId,
    pipelineId,
    internalNode,
    isPanelActive,
    isPreviewMode,
    onConfigureNode,
    executedNodeStatus,
  } = usePipelineNode<TWebhookTriggerNodeConfig>(id);

  const webhookUrl = `${baseUrl}/v2/pipelines/webhook/${workspaceId}/${pipelineId}`;

  const renderCopyWebhookUrl = (
    <div className="h-4 py-3 flex items-center border justify-between rounded pl-2 bg-gray-100">
      <p className="text-xs ellipsis text-gray-500 flex-1 overflow-hidden">
        {webhookUrl}
      </p>
      <CopyToClipboard text={webhookUrl}>
        <Button
          plain
          onClick={() => message.success("Webhook Copied")}
          className="border shrink-0"
        >
          <DocumentDuplicateIcon />
        </Button>
      </CopyToClipboard>
    </div>
  );

  const {
    icon: Icon,
    label,
    color,
  } = NodeUIRegistry[NodeType.WEBHOOK_TRIGGER]["default"];

  return (
    <>
      <Node status={executedNodeStatus}>
        <NodeHeader>
          <NodeBadge
            color={color}
            label={label}
            icon={<Icon className="size-4" />}
          />

          <NodeActions hideActions={isPanelActive}>
            {!isPreviewMode && <AddStepAction onAddStep={handleAdd} />}
            {(!isPreviewMode || isExecuted) && (
              <ConfigureStepAction
                onConfigureStep={() => onConfigureNode(internalNode)}
              />
            )}
          </NodeActions>
        </NodeHeader>
        <NodeBody>
          <NodeName name={data.name} />
          {!isPreviewMode && renderCopyWebhookUrl}
          {isExecuted && (
            <NodeExecutionStatusBadge status={executedNodeStatus} />
          )}
        </NodeBody>
      </Node>

      <Handle
        id="default"
        type="source"
        position={Position.Bottom}
      />
    </>
  );
}
